import { useState, useEffect } from "react";
import * as XLSX from 'xlsx';

import {
  Link,
  useNavigate,
  useSearchParams,
  useParams,
} from "react-router-dom";
import useAxios from "../hooks/useAxios";
import axiosInstance from "../apis/commonAPI";
import { PAGE_LIMITS, modulePermissions } from "../constants";
import { useSelector } from "react-redux";
import Table from "../components/tables/table";
import "react-confirm-alert/src/react-confirm-alert.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    expertLocSlotFieldData,
  expertuserSlotTableData,
} from "../data/TableData";
import moment from "moment";
import UserQueryAlert from "../components/UserQueryAlert";
import { useForm, FormProvider } from "react-hook-form";


export default function LocationWiseExpSlots() {

  const { SESSION_DATA, user } = useSelector((state) => state.user);
  const GET_STATE_DIST_URL = `master/getStateDistrictData`;
  const GET_STATE_BY_LOC = `master/getStateByLocationData`;
  const FETCH_API_URL = `expert/getExpAllReportData?`;


    const currTime = moment().format("hh:mm A");
  
  const currDate = moment().format("YYYY-MM-DD");

    const navigate = useNavigate();

    const [search, setSearch] = useState("");
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(PAGE_LIMITS[0]);
    const [totalCount, setTotalCount] = useState(0);
    const [stateDistInfo, setStateDistInfo] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [addUpdateSubmit, setAddUpdateSubmit] = useState(false);
    const [downloadExcelFlag, setDownloadExcelFlag] = useState(false);
    const [stateByLoc, setStateByLoc] = useState([]);
    const [districtByLoc, setDistrictByLoc] = useState([]);
    const [currState, setCurrState] = useState({});
    const [DomainDataFlag, setDomainDataFlag] = useState([]);
    const [subDomainFlag, setSubDomainFlag] = useState(null);
    const [locId, setLocId] = useState("");
    const [expDomId, setExpDomId] = useState("");
    const [slotType, setSlotType] = useState("A");
    const [formDataInfo, setFormDataInfo] = useState({});


    const [locationData, errorLocation, loadingLocation, axiosLocation] = useAxios();
    const [stateByLocData, errorStateByLoc, loadingStateByLoc, axiosFetchStateByLoc] =  useAxios();
    const [stateDistData, errorStateDist, loadingStateDist, axiosFetchStateDist] =  useAxios();
    const [domainSubDomainData, errorinSubDomain, loadingDomainSubDomain, axiosDomainSubDomain] =  useAxios();
    const [expData, errorSubmit, loadingSubmit, axiosSubmit] = useAxios();
      const [reportData, errorReport, loadingReport, axiosFetchReport] = useAxios();





   
  
  


    
      


    


     const form = useForm({
        defaultValues: {
            slotType:"A"
          // slotStartDate: curDate,
          // slotEndDate: tomorrow,
        },
      });
      const {
        register,
        control,
        handleSubmit,
        formState,
        watch,
        setValue,
        getValues,
        resetField,
        reset,
      } = form;
      const { errors } = formState;


       const getStateData = (url) => {
                    axiosFetchStateDist({
                        axiosInstance: axiosInstance,
                        url: url,
                        method: "GET",
                      });
                };
              const getStateByLocationData = (url) => {
                    axiosFetchStateByLoc({
                        axiosInstance: axiosInstance,
                        url: url,
                        method: "GET",
                      });
                };
                 const getLocationData = (url) => {
                      axiosLocation({
                        axiosInstance: axiosInstance,
                        url: url,
                        method: "GET",
                      });
                    };

                      const getDomainSubDomainData = (url) => {
                          axiosDomainSubDomain({
                            axiosInstance: axiosInstance,
                            url: url,
                            method: "GET",
                          });
                        };
            
                 useEffect(() => {
                    getStateData(GET_STATE_DIST_URL);   
                },[GET_STATE_DIST_URL]);
      
                 useEffect(() => {
                    getStateByLocationData(GET_STATE_BY_LOC);   
                },[GET_STATE_BY_LOC]);
            
                useEffect(() => {
                  setStateDistInfo(stateDistData?.[0]?.StateDistrictsData) 
              },[loadingStateDist]);
      
                useEffect(() => {
                  if(stateByLocData?.[0]?.success){
                  setStateByLoc(stateByLocData?.[0]?.data?.distinctStates); 
                  setDistrictByLoc(stateByLocData?.[0]?.data?.distinctDistricts) 
                  }else{
                    setStateByLoc([])
                    setDistrictByLoc([])
                  }
              },[loadingStateByLoc]);


//   const getData = (url) => {
//     axiosFetch({
//       axiosInstance: axiosInstance,
//       url: url,
//       method: "GET",
//     });
//   };
 

  const handleSearchFieldChange = (e) => {
    if (e.key === "Enter") {
      setSearch(e.target.value);
    }
  };

  const handleLimitChange = (e) => {
    setLimit(e.target.value);
  };

  const onFormSubmit = async (data) => {
    let stateId = data?.state?data?.state.split("_")[0]:"";
    let districtId = data?.district?data?.district.split("_")[0]:"";
    let formData = {
        stateId: stateId || "",
        districtId: districtId || "",
        locationId: data?.location || "",
        expertId: data?.expertAvail || "",
        fromDate: data?.fromDate || "",
        toDate: data?.toDate || "",
        downloadFlag: false

   
    };
    setFormDataInfo(formData);

    await axiosFetchReport({
      axiosInstance: axiosInstance,
      url: `${FETCH_API_URL}search=${search}&skip=${page > 0 ? page * limit : 0}&limit=${limit}`,
      method: "POST",
      requestConfig: {
        data: formData,
      },
    });
  
    setAddUpdateSubmit(true);
    };
     useEffect(() => {
               if(!downloadExcelFlag && addUpdateSubmit && reportData?.[0]?.success){
                 if (reportData?.[0]?.['data'] !== undefined && reportData?.[0]?.['data'].length > 0) {

                      const tempData = reportData?.[0]?.['data']?.map((item) => {

                        const subDomainNames = item.expertSubDomain
                        ?.map(sub => sub.subDomainName)
                        .filter(name => !!name)
                        .join(', ');

                        let morningSlotData = item?.morningSlot
                        ?.filter(sub => sub.status === slotType)
                        .map(sub => sub.time)
                        .filter(time => !!time)
                        .join(', ');
                      
                        let afternoonSlotData = item?.afternoonSlot
                        ?.filter(sub => sub.status === slotType)
                        .map(sub => sub.time)
                        .filter(time => !!time)
                        .join(', ');
    
                        let eveningSlotData = item?.eveningSlot
                        ?.filter(sub => sub.status === slotType)
                        .map(sub => sub.time)
                        .filter(time => !!time)
                        .join(', ');
    
                        let nightSlotData = item?.nightSlot
                        ?.filter(sub => sub.status === slotType)
                        .map(sub => sub.time)
                        .filter(time => !!time)
                        .join(', ');
                        
                        return {
                          _id: item?._id,
                          locationName: item?.locationName,
                          expertName: item?.expertName,
                          expertDomain: item?.expertDomain,
                          expertSubDomain: subDomainNames,
                          slotDate: moment(item?.slotDate).format("Do MMMM YYYY"),
                          morningSlot: morningSlotData?morningSlotData:"-",
                          afternoonSlot: afternoonSlotData?afternoonSlotData:"-",
                          eveningSlot: eveningSlotData?eveningSlotData:"-",
                          nightSlot: nightSlotData?nightSlotData:"-",
                        
                
                    };
                      });
                      setTotalCount(reportData?.[0]?.totalCount);

                      setTableData(tempData);
                      toast.info(
                        reportData?.[0]?.message ,
                         {
                           position: toast.POSITION.TOP_RIGHT,
                           autoClose: 2000
    
                         }
                       );
                    } else {
                              setTotalCount(0);
                      setTableData([]);
                      toast.info(
                        "Success!! No Slot available" ,
                         {
                           position: toast.POSITION.TOP_RIGHT,
                           autoClose: 2000
    
                         }
                       );
                    }
             
               }else if (addUpdateSubmit && !reportData?.[0]?.success){
                toast.error(
                    reportData?.[0]?.message ,
                     {
                       position: toast.POSITION.TOP_RIGHT,
                       autoClose: 2000
                     }
                   );
    
               }
               setAddUpdateSubmit(false);
    
    
             },[loadingReport,search, page, limit])


 

    

 

      const handleDistrict = (e) => {
        resetField("district");
        resetField("location");
        resetField("expertDomain");
        resetField("expertSubDomain");
        resetField("expertAvail");
  
        const [stateId, stateName] = e.target.value.split("_");  
        const filteredDistricts = stateDistInfo?.find(
          (item) => item._id === stateId
        )?.districts;  
        if (filteredDistricts) {
          const districtOptions = filteredDistricts?.map((district) => ({
            id: district?._id,
            districtName: district?.districtName,
          }));
  
          const commonDistricts = districtOptions.filter(md =>
            districtByLoc.some(sd => sd._id === md.id && sd.districtName === md.districtName)
          );
          
          setDistrictData( commonDistricts);
          setCurrState(prev => ({
            ...prev,
            stateId,
            stateName
          }));
              } else {
            setDistrictData([]);
            setCurrState({});
        }
      };

      const handleLocation = (e) => {
           
            resetField("location");
            resetField("expertDomain");
            resetField("expertSubDomain");
            resetField("expertAvail");
            const selectedMode = e.target.value;
            const [districtId, districtName] = e.target.value.split("_");  
                if (selectedMode) {
                     getLocationData(`master/getLocationDataByStateDistrict/${currState?.stateId}/${districtId}`);
                }  
        }

      

        const handleDomain = (getVal) => {
           
            resetField("expertDomain");
            resetField("expertSubDomain");
            resetField("expertAvail");
            const selectedLocation = getVal;  
            if (selectedLocation !== "") {
              let locationId = selectedLocation?.split('___')?.[0];
              setLocId(locationId);
              getDomainSubDomainData(`expert/getDomainSubDomainByLocation/${locationId}/offline`);
      
            } 
          };
          const handleDownloadExcel = async () =>{
            let formExclData = {
                stateId: formDataInfo?.stateId || "",
                districtId: formDataInfo.districtId || "",
                locationId: formDataInfo.locationId || "",
                expertId: formDataInfo.expertId || "",
                fromDate: formDataInfo.fromDate || "",
                toDate: formDataInfo.toDate || "",
                downloadFlag: true
        
           
            };
           
        
            await axiosFetchReport({
              axiosInstance: axiosInstance,
              url: `${FETCH_API_URL}search=${search}&skip=${page > 0 ? page * limit : 0}&limit=${limit}`,
              method: "POST",
              requestConfig: {
                data: formExclData,
              },
            });
            setDownloadExcelFlag(true);
           
          }
          useEffect(() => {
            if(downloadExcelFlag  && reportData?.[0]?.success){
              const toTitleCase = (str) => {
                return str.toLowerCase().replace(/(^|\s|-|\')(\w)/g, (match) => {
                  return match.toUpperCase();
                });
              };
              let fileName = `${user?.expertName || ""}_BookedSlotExcelData.xlsx`;
            
              const jsonData = reportData?.[0]?.['data']?.map((item) => {
  
                  const subDomainNames = item.expertSubDomain
                  ?.map(sub => sub.subDomainName)
                  .filter(name => !!name)
                  .join(', ');
  
                  let morningSlotData = item?.morningSlot
                  ?.filter(sub => sub.status === slotType)
                  .map(sub => sub.time)
                  .filter(time => !!time)
                  .join(', ');
                
                  let afternoonSlotData = item?.afternoonSlot
                  ?.filter(sub => sub.status === slotType)
                  .map(sub => sub.time)
                  .filter(time => !!time)
                  .join(', ');
  
                  let eveningSlotData = item?.eveningSlot
                  ?.filter(sub => sub.status === slotType)
                  .map(sub => sub.time)
                  .filter(time => !!time)
                  .join(', ');
  
                  let nightSlotData = item?.nightSlot
                  ?.filter(sub => sub.status === slotType)
                  .map(sub => sub.time)
                  .filter(time => !!time)
                  .join(', ');
            
                   
            
                return {
                      LocationName: item?.locationName,
                      ExpertName: item?.expertName,
                      ExpertDomain: item?.expertDomain,
                      ExpertSubDomain: subDomainNames,
                      SlotDate: moment(item?.slotDate).format("Do MMMM YYYY"),
                      MorningSlot: morningSlotData?morningSlotData:"-",
                      AfternoonSlot: afternoonSlotData?afternoonSlotData:"-",
                      EveningSlot: eveningSlotData?eveningSlotData:"-",
                      NightSlot: nightSlotData?nightSlotData:"-",
  
                  }
                           
            
              });
             
            
              const worksheet = XLSX.utils.json_to_sheet(jsonData);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                XLSX.writeFile(workbook, fileName);
            
              
                  toast.info(
                    "Excel file downloaded successfully!!",
                    {
                      position: toast.POSITION.TOP_RIGHT,
                      autoClose: 1000
  
                    }
                  );
                 
            
               
            }else if(downloadExcelFlag){
              toast.info(
                "No booking slot found for download!!",
                {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1000
  
                }
              );
    
             
            
            }
    
         
          setDownloadExcelFlag(false);
    
    
    
        },[downloadExcelFlag])

            useEffect(() => {
                  if(domainSubDomainData?.[0]?.success){
                    const uniqueDomainDataFlag = domainSubDomainData?.[0]?.data?.filter(
                      (item, index, self) =>
                        index === self.findIndex((t) => t.domain === item.domain)
                    );
                    
                    setDomainDataFlag(uniqueDomainDataFlag)
                   
            
                  }else if(!domainSubDomainData?.[0]?.success){
                    toast.error(domainSubDomainData?.[0]?.message, {
                      position: toast.POSITION.TOP_RIGHT,
                      autoClose: 200,
                    });
            
                  }
            
                },[domainSubDomainData])

                const handleSubdomain = (getValue) => {
                    resetField("expertSubDomain");
            resetField("expertAvail");
                    
                    if (getValue.target.value !== "") {
                        setExpDomId(getValue.target.value );
                      DomainDataFlag?.map((fetchRows, index) => {
                        if (fetchRows?.domain == getValue.target.value) {
                          setSubDomainFlag(fetchRows?.subDomain);
                        }
                      });
                    } else {
                      setSubDomainFlag(null);
                      setExpDomId("")
                    }
                  };

                  const handleExpert = async (getSubDomId = "") => {
                    resetField("expertAvail");
                    let expData = {
                        mode:"offline",
                        locationId:locId,
                        domainId: expDomId,
                        subDomainId: getSubDomId,
                        getStatus: "A",
                      };
                      await axiosSubmit({
                        axiosInstance: axiosInstance,
                        url: "expert/getExpertByDomain",
                        method: "POST",
                        requestConfig: {
                          data: expData,
                        },
                      });
                  
                    };

   
  return (
    <>
      <div className="card min-height-100">
        <div className="pump-report-top">
          <h2 className="text-navyBlue">Location Wise Expert Slots</h2>
          <ToastContainer />

          <div className="wrapper">

          <button
                  type="button"
                  className="btn  btn-green rounded-10 mr-10"
                  value="Download"
                  onClick= {handleDownloadExcel
                    
                   
                  }
                >
                  Download Excel
                </button> 
                {user?.usertype == "expert" ? (
            <></>
          ) : (
            <Link to="/expert/expertlisting">
              <button className="btn btn-blue rounded-10">Back</button>
            </Link>
          )}
          </div>
          
        </div>


      
        

<FormProvider {...form}>
          <form onSubmit={handleSubmit(onFormSubmit)} noValidate>
            <div className="row mt-30">

            <div className="col-md-3 ">
              <label htmlFor="state" className="text-gray text-semi-bold">
              State 
                </label>
              <select
                  id="state"
                  {...register("state", {
                    required: {
                      value: false,
                      message: "State field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10"
                  placeholder="Select State"
                  onChange={handleDistrict}

                >
                  <option value="">Select State</option>
                  {stateByLoc?.map((listFetch, index) => (
                        <option
                        key={listFetch?._id}

                          value={`${listFetch?._id}_${listFetch?.stateName}`}
                        >
                          {listFetch?.stateName}
                        </option>
                      ))}
                  
                </select>
                <p className="text-red">{errors.state?.message}</p>
              </div> 

              <div className="col-md-3  tank-col-info">
                    <label
                      htmlFor="district"
                      className="text-gray text-semi-bold"
                    >
                      District
                    </label>

                    <select
                      id="district"
                      {...register("district", {
                        required: {
                          value: false,
                          message: "District Field is Required",
                        },
                      })}
                      type="text"
                      className="form-control rounded-10 mb-15"
                      placeholder="Select District"
                      onChange={(e) => handleLocation(e)}
                      
                    >
                      <option value="">Select District</option>
                      {districtData?.map((listFetch, index) => (
                        <option
                          value={`${listFetch?.id}_${listFetch?.districtName}`}
                          selected ={`${locationData[0]?.districtId}` === `${listFetch?.id}`}

                        >
                          {listFetch?.districtName}
                        </option>
                      ))}
                    </select>

                    <p className="text-red">{errors.district?.message}</p>
                  </div>

                  <div className="col-md-3 ">
              <label htmlFor="location" className="text-gray text-semi-bold">
                 Location 
                </label>
              <select
                  id="location"
                  {...register("location", {
                    required: {
                      value: false,
                      message: "Location field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10"
                  placeholder="Select Location"
                  onChange={(e) => handleDomain(e.target.value)}
                >
                  <option value="">Select Location</option>
                  {locationData?.[0]?.success && locationData?.[0]?.data?.map((fetchRow, index) => (
                    <option value={fetchRow?._id}>
                      {fetchRow?.locationName}
                    </option>
                  ))}
                </select>
                <p className="text-red">{errors.location?.message}</p>
              </div>

              <div className="col-md-3  tank-col-info ">
                <label htmlFor="state" className="text-gray text-semi-bold">
                  Expert Domain 
                </label>

                <select
                  id="expertDomain"
                  {...register("expertDomain", {
                    required: {
                      value: false,
                      message: "Domain field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10"
                  placeholder="Select Expert Domain"
                  onChange={(e) => handleSubdomain(e)}
                >
                  <option value="">Select Expert Domain</option>
                  {DomainDataFlag?.map((fetchRow, index) => (
                    <option value={fetchRow?.domain}>
                      {fetchRow?.domainName}
                    </option>
                  ))}
                </select>
                <p className="text-red">{errors.expertDomain?.message}</p>
              </div>
              <div className="col-md-3  tank-col-info">
                <label htmlFor="expertSubDomain" className="text-gray text-semi-bold">
                  Expert Sub-Domain 
                </label>
                <select
                  id="expertSubDomain"
                  {...register("expertSubDomain", {
                    required: {
                      value: false,
                      message: "Expert Sub Domain field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10"
                  placeholder="Select Expert SubDomain"
                  onChange={(e) => handleExpert(e.target.value)}

                  
                 
                >
                  
                  <option value=""> Select Expert Sub-Domain </option>

                  {subDomainFlag?.map((fetchRow, index) => (
                    <option value={fetchRow?.subDomainId}>
                      {fetchRow?.subDomainName}
                    </option>
                  ))}  
                </select>
                <p className="text-red">{errors.expertSubDomain?.message}</p>
              </div>
              <div className="col-md-3  tank-col-info">
                <label htmlFor="expertAvail" className="text-gray text-semi-bold">
                  Experts 
                </label>
                <select
                  id="expertAvail"
                  {...register("expertAvail", {
                    required: {
                      value: false,
                      message: "Expert field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10"
                  placeholder="Select Expert "

                  
                 
                >
                  
                  <option value=""> Select Available Expert  </option>

                  {expData?.[0]?.data?.map((fetchRow, index) => (
                    <option value={fetchRow?._id}>
                      {fetchRow?.expertName}
                    </option>
                  ))}  
                </select>
                <p className="text-red">{errors.expertAvail?.message}</p>
              </div>

              <div className="col-md-3">  
              <label htmlFor="expertAvail" className="text-gray text-semi-bold">
                  Slot Type 
                </label>              
                      <select
                      id="slotType"
                      {...register("slotType", {
                        required: {
                          value: false,
                          message: "Slot Type Field is Required",
                        },
                      })}
                      type="text"
                      className="form-control  mb-15 rounded-10"
                      placeholder="Select Slot type"
                      onClick = {(e) => setSlotType(e.target.value)}
                    >
                      <option value="A">Available By Expert</option>
                      <option value="V">Vacant For Expert </option>
                      <option value="B">Booked by User</option>
                      
                    </select>
                        <p className="text-red">{errors.slotType?.message}</p>
                      </div>

           
            
             
              
              <div className="col-md-3  tank-col-info">
                <label
                  htmlFor="fromDate"
                  className="text-gray text-semi-bold"
                >
                  From  Date
                </label>
                
                 <input
  id="fromDate"
  type="date"
  className="form-control mb-15 rounded-10"
  {...register("fromDate", {
    required: { value: false, message: "Enter From Date" },
    validate: (value) => {
      const toDate = new Date(getValues("toDate"));
      const fromDate = new Date(value);

      return (
        !getValues("toDate") ||
        fromDate < toDate ||
        "From Date must be earlier than To Date"
      );
    },
  })}
/>
                <p className="text-red">{errors.fromDate?.message}</p>
              </div>
              <div className="col-md-3  tank-col-info">
                <label
                  htmlFor="toDate"
                  className="text-gray text-semi-bold"
                >
                  To Date
                </label>
               
                <input
  id="toDate"
  type="date"
  className="form-control mb-15 rounded-10"
  // min={moment().add(1, "day").format("YYYY-MM-DD")}
  {...register("toDate", {
    required: { value: false, message: "Enter To Date" },
    validate: (value) => {
      const fromDate = new Date(getValues("fromDate"));
      const toDate = new Date(value);

      return (
        !getValues("fromDate") ||
        toDate > fromDate ||
        "To Date must be after From Date"
      );
    },
  })}
/>
                <p className="text-red">{errors.toDate?.message}</p>
              </div>
             

              

              <div className="col-md-3  ">
                <input
                  type="submit"
                  className="btn btn-m btn-secondary rounded-20 mt-20"
                  value="Submit"
                />
              </div>
             
            </div>
          </form>
        </FormProvider>




        <div className="pump-search">
          <span className="text-gray">
            {" "}
            Show Entries
            <select
              type="text"
              className="p-5 rounded-20 ml-10 no-bg border-darkGray text-gray"
              onChange={handleLimitChange}
            >
              {PAGE_LIMITS.map((value, index) => (
                <option key={index} value={value}>
                  {value}
                </option>
              ))}
            </select>
          </span>

          {/* <span>
            {" "}
            <input
              type="text"
              className="p-5 rounded-20 ml-10 no-bg border-darkGray text-gray"
              placeholder="Search"
              onKeyDown={handleSearchFieldChange}
            />
          </span> */}
        </div>
        <div className="company-table ">
          <Table
            tableColumns={expertLocSlotFieldData}
            tableData={tableData}
            tableSettings={{
              page,
              pageSize: limit,
              totalCount,
            }}
            // action={true}
            
            handlePage={setPage}

            
          />
        </div>
      </div>
     
    </>
  );
}
